import React from "react"
import { Modal, Button } from "antd"
import "./TermsOfService.scoped.scss"

const PrivacyPolicy = ({ open, setOpen, setIsAgree }) => {
  const termsData = {
    title: "นโยบายความเป็นส่วนตัวสำหรับลูกค้า / Privacy Policy",
    announcement: "ประกาศฉบับนี้ให้มีผลบังคับใช้ตั้งแต่วันที่ 17 มิถุนายน 2568 เป็นต้นไป",
    sections: [
      {
        content: "บริษัท แอดวานซ์ เน็ตเวิร์ค เทคโนโลยี แอนด์ เซอร์วิส จำกัดได้ตระหนักถึงความสำคัญของการคุ้มครองข้อมูลส่วนบุคคล และมีความยินดีเป็นอย่างยิ่งที่ท่านให้ความสนใจในการใช้บริการ ของเรา บริษัทจึงได้จัดทำนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ขึ้นเพื่อใช้บังคับกับเจ้าของข้อมูลส่วนบุคคลซึ่งใช้บริการ ทำธุรกรรม หรือร่วมกิจกรรม ใดๆ โดยครอบคลุมผลิตภัณฑ์และบริการในเครือของบริษัท ได้แก่ เว็บไซต์ โซเชียลมีเดีย (Social Media) และช่องทางอื่นๆ ในอนาคต โดยมีหลักเกณฑ์ กลไก มาตรการกำกับดูแล และการบริหารจัดการข้อมูลส่วนบุคคลตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562 เราอาจแก้ไขเปลี่ยนแปลง นโยบายนี้เป็นครั้งคราว โดยท่านสามารถทราบข้อกำหนดและเงื่อนไขนโยบายที่มีการแก้ไขเปลี่ยนแปลงนี้ได้ผ่านทางเว็บไซต์ของเรา นโยบายนี้แก้ไขล่าสุด และมีผลใช้บังคับตั้งแต่วันที่ 17 มิถุนายน 2568"
      },
      {
        title: "1. ข้อมูลส่วนบุคคลที่เราเก็บ",
        content:
          "บริษัทจะเก็บรวบรวมข้อมูลส่วนบุคคลที่ท่านได้กรอกเข้ามา โดยมีวัตถุประสงค์ ขอบเขตและใช้วิธีการที่ชอบด้วยกฎหมาย ข้อมูลส่วนบุคคลทั้งหมด ต้องถูกให้ความยินยอมจากเจ้าของข้อมูลส่วนบุคคลนั้นแล้ว โดยในการเก็บนั้นจะทำเพียงเท่าที่จำเป็นแก่การดำเนินงานภายใต้วัตถุประสงค์ของบริษัท ทั้งนี้บริษัทจะดำเนินการให้เจ้าของข้อมูลรับรู้ให้ความยินยอมทางอิเล็กทรอนิกส์ หรือตามแบบวิธีการของบริษัท \nบริษัทอาจมีการเก็บข้อมูลเพิ่มหลังจากที่ท่านได้มีการทำธุรกรรม ทั้งในรูปแบบบุคคลและนิติบุคคลเพื่อสนันสนุนการใช้งานและประสบการณ์ของท่าน ให้ดีที่สุด",
      },
      {
        title: "2. การประมวลผลข้อมูลส่วนบุคคล",
        content:
          "เราจะประมวลผลข้อมูลส่วนบุคคลของคุณเพื่อให้บริการตามที่ท่านสมัคร ร้องขอ และ เพื่อการให้บริการที่มีประสิทธิภาพสูงสุด โดยข้อมูลของท่านเราจะนำไปใช้เพื่อวัตถุประสงค์ดังต่อไปนี้",
        additionalTerms: [
          "ก. เพื่อสร้างและจัดการบัญชีผู้ใช้งาน",
          "ข. เพื่อจัดส่งสินค้าหรือบริการ",
          "ค. เพื่อปรับปรุงสินค้า บริการ หรือประสบการณ์การใช้งาน",
          "ง. เพื่อการบริหารจัดการภายในบริษัท",
          "จ. เพื่อการตลาดและการส่งเสริมการขาย",
          "ฉ. เพื่อการบริการหลังการขาย",
          "ช. เพื่อรวบรวมข้อเสนอแนะ",
          "ซ. เพื่อชำระค่าสินค้าหรือบริการ",
          "ฌ. เพื่อปฏิบัติตามข้อตกลงและเงื่อนไข (Terms and Conditions)",
          "ญ. เพื่อปฏิบัติตามกฎหมายและกฎระเบียบของหน่วยงานราชการ",
        ],
      },
      {
        title: "3. วิธีการเก็บรักษาข้อมูลส่วนบุคคลและความปลอดภัย",
        content:
          "เราจะรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของท่านไว้ตามหลักการการรักษาความลับ ความถูกต้องครบถ้วน และสภาพพร้อมใช้งาน เพื่อป้องกันการสูญหาย เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข หรือเปิดเผย นอกจากนี้เราจะจัดให้มีมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล ซึ่งครอบคลุมถึงมาตรการป้องกันด้านการบริหารจัดการ มาตรการป้องกันด้านเทคนิค และมาตรการป้องกันทางกายภาพ ในเรื่องการเข้าถึงหรือ ควบคุมการใช้งานข้อมูลส่วนบุคคล",
      },
      {
        title: "4. การเปิดเผยข้อมูลส่วนบุคคล",
        content:
          "บริษัทอาจเปิดเผยข้อมูลส่วนบุคคลของคุณให้แก่ผู้อื่นภายใต้ความยินยอมของคุณหรือที่กฎหมายอนุญาตให้เปิดเผยได้และอาจเปิดเผยข้อมูลส่วนบุคคลของคุณภายในบริษัทเท่าที่จำเป็น เพื่อวัตถุประสงค์ในการปรับปรุงพัฒนาสินค้าหรือบริการที่ตอบสนองความต้องการของคุณ รวมไปถึงการนำเสนอ การประชาสัมพันธ์สินค้า บริการ และกิจกรรมที่เกี่ยวข้องทางการตลาด และบริษัทอาจรวบรวมข้อมูลภายในสำหรับสินค้าหรือบริการต่าง ๆ ภายใต้ นโยบายนี้ เพื่อประโยชน์ของคุณและผู้อื่นมากขึ้น",
      },
      {
        title: "5. สิทธิของเจ้าของข้อมูลส่วนบุคคล ",
        content:
          "บริษัท แอดวานซ์ เน็ตเวิร์ค เทคโนโลยี แอนด์ เซอร์วิส จำกัด ให้ความเคารพและยึดมั่นในสิทธิของเจ้าของข้อมูลส่วนบุคคล ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 โดยท่านมีสิทธิดังต่อไปนี้:",
        additionalTerms: [
          "(ก) สิทธิในการเพิกถอนความยินยอม: \nท่านสามารถเพิกถอนความยินยอมในการเก็บ ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านได้ตลอดเวลา",
          "(ข) สิทธิในการเข้าถึงข้อมูล: \nท่านมีสิทธิขอรับสำเนาข้อมูลส่วนบุคคลของตน และตรวจสอบที่มาของข้อมูลนั้น",
          "(ค) สิทธิในการขอถ่ายโอนข้อมูล: \nท่านสามารถขอให้บริษัทโอนข้อมูลของท่านไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่น",
          "(ง) สิทธิในการคัดค้านการประมวลผลข้อมูล: \nท่านมีสิทธิคัดค้านการประมวลผลข้อมูลในบางกรณีตามที่กฎหมายกำหนด",
          "(จ) สิทธิในการลบหรือทำลายข้อมูล: \nท่านสามารถร้องขอให้บริษัทลบหรือทำลายข้อมูลส่วนบุคคลของท่าน หรือทำให้เป็นข้อมูลที่ไม่สามารถระบุตัวตนได้",
          "(ฉ) สิทธิในการระงับการประมวลผลข้อมูล: \nท่านสามารถขอระงับการประมวลผลข้อมูลส่วนบุคคลในบางกรณี เช่น อยู่ระหว่างการตรวจสอบความถูกต้อง",
          "(ช) สิทธิในการแก้ไขข้อมูลให้ถูกต้อง: \nท่านมีสิทธิขอให้บริษัทแก้ไขข้อมูลที่ไม่ถูกต้องหรือไม่เป็นปัจจุบัน",
          "(ซ) สิทธิในการร้องเรียน: \nหากท่านเห็นว่าบริษัทละเมิดสิทธิของท่านตาม พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล ท่านมีสิทธิยื่นคำร้องต่อหน่วยงานที่มีอำนาจตามกฎหมาย",
        ],
      },
      {
        title: "6. รายละเอียดการติดต่อ",
        content:
          "หากท่านต้องการใช้สิทธิของท่านตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 เช่น การเข้าถึงข้อมูล แก้ไขข้อมูล ลบข้อมูล หรือเพิกถอนความยินยอม รวมถึงหากมีข้อสงสัยเกี่ยวกับนโยบายความเป็นส่วนตัวของบริษัท ท่านสามารถติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล ได้ที่:",
      },
    ],
  }

  const handleClose = () => {
    setIsAgree()
    setOpen(false)
  }

  return (
    <Modal
      visible={open}
      onCancel={() => setOpen("")}
      footer={null}
      centered
      width={600}
      className="terms-of-service-modal"
      closeIcon={false}
      zIndex={1021}
    >
      <div className="terms-modal-container">
        <div className="terms-modal-title">{termsData.title}</div>

        <div className="terms-modal-content">
          {termsData.sections.map((section, index) => (
            <div key={index} className="terms-modal-section-detail">
              {section.title && <div className="terms-modal-section-title">{section.title}</div>}

              {section.content.split("\n").map((line, i) => (
                <div key={i} className="terms-modal-paragraph">
                  {line}
                </div>
              ))}

              {/* Only render additional terms if they exist for this section */}
              {section.additionalTerms && (
                <div className="terms-modal-list">
                  {section.additionalTerms.map((term, termIndex) => (
                    <div key={termIndex} className="terms-modal-list-item">
                      {term.split("\n").map((line, i) => (
                        <div key={i}>{line}</div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          <div className="company-detail">
            <div>บริษัท แอดวานซ์ เน็ตเวิร์ค เทคโนโลยี แอนด์ เซอร์วิส</div>
            <div>42/92 ซอยเลี่ยงเมืองนนทบุรี 10 ถนนเลี่ยงเมืองนนทบุรี ตำบลบางกระสอ อำเภอเมือง จังหวัดนนทบุรี 11000</div>
            <div className="ml-3">อีเมล: dpo@ants.co.th</div>
            <div className="ml-3">LINE : @ANTS </div>
            <div className="ml-3">เวลาทำการ: วันจันทร์ – ศุกร์ เวลา 09.00 – 18.00 น. (ยกเว้นวันหยุดราชการ)</div>
            <div>บริษัทจะดำเนินการตอบกลับคำร้องขอของท่านภายในระยะเวลาที่กฎหมายกำหนด (โดยทั่วไปไม่เกิน 30 วัน)</div>
          </div>

        </div>

        <Button className="terms-modal-done-btn" type="primary" block onClick={() => handleClose()}>
          Done
        </Button>
      </div>
    </Modal>
  )
}

export default PrivacyPolicy
